module.exports = __webpack_public_path__ + "static/media/dsc_7945.4efce207.jpg";